import React from "react";
import { Button, Tooltip } from "antd";
import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createNoticePopupState } from "../../../../store/actions/actions";
import { DraftIcon, PlayIcon } from "../../../../../../resource/icons";
import useCreateNoticeCancel from "../../../../hooks/useCreateNoticeCancel";
import useCreateNoticeValidator from "../../../../hooks/useCreateNoticeValidator";
import createNotice from "../../../../store/thunks/createNotice";
import { useHistory, useParams, useLocation } from "react-router-dom";
import getNoticesPreview from "../../../../store/thunks/getNoticesPreview";

const Wrapper = ({ children, disabled, errors }) => {
	if (disabled) {
		return (
			<span style={{ marginLeft: "8px" }}>
				<Tooltip title={errors}>{children}</Tooltip>
			</span>
		);
	} else {
		return <Fragment>{children}</Fragment>;
	}
};

const NextStep = ({ disabled, page, errors }) => {
	const dispatch = useDispatch();

	return (
		<Wrapper disabled={disabled} errors={errors}>
			<Button
				type="primary"
				onClick={() => {
					dispatch(createNoticePopupState({ page: page + 1 }));
				}}
				disabled={disabled}
			>
				Далее
			</Button>
		</Wrapper>
	);
};

const PrevStep = ({ page }) => {
	const dispatch = useDispatch();

	return (
		<Button
			onClick={() => {
				dispatch(createNoticePopupState({ page: page - 1 }));
			}}
		>
			Назад
		</Button>
	);
};

const Cancel = () => {
	const onCancel = useCreateNoticeCancel();
	return <Button onClick={() => onCancel()}>Отмена</Button>;
};

const FirstStep = () => {
	const dispatch = useDispatch();

	return (
		<Button
			onClick={() => {
				dispatch(createNoticePopupState({ page: 0 }));
			}}
		>
			В начало
		</Button>
	);
};

const Play = ({ disabled, errors, setPlayConfirm }) => {

	return (
		<Wrapper disabled={disabled} errors={errors}>
			<Button
				className={disabled ? "" : "play button"}
				disabled={disabled}
				onClick={() => setPlayConfirm(true)}
			>
				<PlayIcon />
				<span>Запустить оповещение</span>
			</Button>
		</Wrapper>
	);
};

const Save = ({ disabled, errors, setLoading }) => {
	const dispatch = useDispatch();
	const history = useHistory();
	const { fileId } = useParams();
	const location = useLocation();

	const params = new URLSearchParams(location.search);
  const companyIdFromUrl = params.get('companyId');

	return (
		<Wrapper disabled={disabled} errors={errors}>
			<Button
				type="primary"
				onClick={async () => {
					setLoading(true)
					const noticeId = await dispatch(createNotice());
					setLoading(false)
					dispatch(createNoticePopupState({ popupOpened: false }));
					await dispatch(getNoticesPreview(fileId));
					history.push({
							pathname: `/Debts/file/${fileId}/notice/${noticeId}`,
							search: `?companyId=${companyIdFromUrl}`,
						});
				}}
				className={disabled ? "" : "button"}
				disabled={disabled}
			>
				<DraftIcon />
				Cохранить
			</Button>
		</Wrapper>
	);
};

const Buttons = ({ setPlayConfirm, setLoading }) => {
	const createNotice = useSelector(
		(store) => store.debtsStore.createNotice
	);
	const [disabled, errors] = useCreateNoticeValidator();
	const { page, lastPage } = createNotice;

	if (!page) {
		return (
			<>
				<Cancel />
				<NextStep disabled={disabled} page={page} errors={errors} />
			</>
		);
	}

	if (page > 0 && page < lastPage) {
		return (
			<div
				style={
					page > 1 ? { display: "flex", justifyContent: "space-between" } : {}
				}
			>
				{page > 1 && <FirstStep />}
				<div>
					<PrevStep page={page} />
					<NextStep disabled={disabled} errors={errors} page={page} />
				</div>
			</div>
		);
	}
	if (page === lastPage) {
		return (
			<div
				style={
					page > 1 ? { display: "flex", justifyContent: "space-between" } : {}
				}
			>
				{page > 1 && <FirstStep />}
				<div>
					<PrevStep page={page} />
					<Play
						setLoading={setLoading}
						disabled={disabled}
						errors={errors}
						setPlayConfirm={setPlayConfirm}
					/>
					{/* <Save disabled={disabled} errors={errors} setLoading={setLoading} /> */}
				</div>
			</div>
		);
	}

	return (
		<>
			{page}
			{lastPage}
		</>
	);
};

export default Buttons;
